// Default site texts (fallback when backend hasn't set custom values)
export const DEFAULT_TEXTS = {
  hero_badge: "Enfermedad rara · CET",
  hero_title_1: "Cada mariposa",
  hero_title_2: "importa",
  hero_subtitle:
    "Acompañamos a familias que conviven con el Complejo de Esclerosis Tuberosa, dando visibilidad a una enfermedad rara y creando comunidad.",
  home_intro:
    "Pequeño Fresno es una asociación creada para dar visibilidad al Complejo de Esclerosis Tuberosa (C.E.T.), acompañar a familias que conviven con esta enfermedad rara y sumar fuerzas junto a personas y organizaciones que creen en el poder de los pequeños gestos.",
  home_cta_cet_title: "¿Qué es el C.E.T.?",
  home_cta_cet_body:
    "Descubre qué es el Complejo de Esclerosis Tuberosa, sus causas, síntomas y tratamientos disponibles.",
  home_cta_asoc_title: "La Asociación",
  home_cta_asoc_body:
    "Conoce cómo nace Pequeño Fresno, qué hacemos y cómo puedes formar parte de esta gran familia.",
  home_banner_title: "Ayúdanos a seguir volando",
  home_banner_body:
    "Cada aportación cuenta. Tu donación contribuye a dar visibilidad al CET y a apoyar a las familias que lo necesitan.",
  cet_intro_1:
    "El Complejo de Esclerosis Tuberosa (CET) es una enfermedad genética rara causada por mutaciones en los genes TSC1 o TSC2. Esta mutación afecta múltiples órganos, incluidos el cerebro, los riñones, la piel y el corazón. Se caracteriza por el crecimiento de tumores benignos en diferentes partes del cuerpo y puede causar una amplia gama de síntomas, como epilepsia, problemas de aprendizaje, trastornos conductuales y complicaciones físicas.",
  cet_intro_2:
    "Aunque no tiene cura, existen tratamientos médicos y terapias especializadas que ayudan a mejorar la calidad de vida de quienes lo padecen. Desde nuestra asociación, trabajamos para ofrecer información, apoyo y recursos para pacientes, familiares y profesionales de la salud.",
};

export const TEXT_LABELS = {
  hero_badge: "Inicio · Etiqueta hero",
  hero_title_1: "Inicio · Hero título línea 1 (serif oscuro)",
  hero_title_2: "Inicio · Hero título línea 2 (cursivo coral)",
  hero_subtitle: "Inicio · Hero párrafo",
  home_intro: "Inicio · Párrafo de introducción",
  home_cta_cet_title: "Inicio · CTA CET (título)",
  home_cta_cet_body: "Inicio · CTA CET (texto)",
  home_cta_asoc_title: "Inicio · CTA Asociación (título)",
  home_cta_asoc_body: "Inicio · CTA Asociación (texto)",
  home_banner_title: "Inicio · Banner donaciones (título)",
  home_banner_body: "Inicio · Banner donaciones (texto)",
  cet_intro_1: "CET · Párrafo 1",
  cet_intro_2: "CET · Párrafo 2",
};
